module.exports = __webpack_public_path__ + "static/media/fotapressa_small.089ba70c.png";